import { Component, input } from '@angular/core';
import { DialogHeaderComponent } from 'common/dialog/header/dialog-header.component';
import { DialogContentComponent } from 'common/dialog/content/dialog-content.component';
import { DialogFooterComponent } from 'common/dialog/footer/dialog-footer.component';
import { DialogContentInnerDirective } from 'common/dialog/content/dialog-content-slots.directive';
import {
  DialogHeaderActionItemsInnerDirective,
  DialogHeaderInnerSubtitleDirective,
  DialogHeaderInnerTitleDirective,
} from 'common/dialog/header/dialog-header-slots.directive';

type DialogSize = 'small' | 'regular' | 'large';

@Component({
  selector: 'comp-dialog',
  templateUrl: 'dialog.component.html',
  styleUrls: ['dialog.component.scss'],
  imports: [
    DialogHeaderComponent,
    DialogContentComponent,
    DialogFooterComponent,
    DialogHeaderActionItemsInnerDirective,
    DialogHeaderInnerSubtitleDirective,
    DialogHeaderInnerTitleDirective,
    DialogContentInnerDirective,
  ],
})
export class DialogComponent {
  readonly dialogCardStyles = input<string>('');
  readonly showCloseIcon = input<boolean>(true);
  readonly closeIconValue = input<unknown>(undefined);
  readonly size = input<DialogSize>('regular');
}
